import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import MailEdit from "../../components/MailEdit";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';

const fetchMeetingRooms = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/meetingRooms`);
    return response.data;
  };
const fetchBookings = async (date) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/BookingDate/${date}`);
    return response.data;
  };
  
export default function Calendar(){

    const navigate = useNavigate();
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
      '&:hover': {
        backgroundColor: 'rgba(255, 83, 46, 1) !important',
      },
      // Add your other styles here
    }));
    const styles = {
        root: {
          display: 'flex',
          overflow: 'auto',
        },
        tableWrapper: {
          width: 'calc(120% - 150px)', // Adjust as needed
          overflowX: 'auto',
        },
        stickyCell: {
          position: 'sticky',
        left: '0px',
        width: '150px', // Adjust this to change the width of the first sticky column
        backgroundColor: '#fff', // Ensure that the sticky cells have a background to avoid content overlapping
        border: '1px solid black',
        },
        subheadingCell: {
            backgroundColor: '#fad784',
            fontWeight: 'bold',
            textAlign: 'center',
          },
      }

      const [booked, setBooked] = useState(null);
      const [tanggalBooking, setTanggalBooking] = useState(new Date())

      const times = Array.from({length: 48}, (_, i) => {
        const hour = Math.floor(i/2);
        const minute = i%2 === 0 ? '00' : '30';
        const nextHour = Math.floor((i+1)/2);
        const nextMinute = (i+1)%2 === 0 ? '00' : '30';
        return `${hour.toString().padStart(2, '0')}:${minute}-${nextHour.toString().padStart(2, '0')}:${nextMinute}`;
      });
    
      const [rooms, setRooms] = useState([]);
      useEffect(() => {
        const date = new Date(); // today's date
        const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD

        fetchMeetingRooms().then(res => {
            if (res) {
              let roomss = res.flatMap(address => {
                return (address.RuangMeeting || []).map(room => ({
                  ...room,
                  location: address.LokasiSingkatan
                }));
              });
              setRooms(roomss);
            } else {
              console.error('Response is undefined: ', res);
            }
          })
          .catch(err => console.error('An error occurred while fetching meeting rooms: ', err));
          
    
        fetchBookings(formattedDate).then(bookings => {
          console.log(bookings)
          const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
          setBooked(bookedCells);
        });
      }, []);

      const changeTanggalBooking = (event) => {
        setTanggalBooking(event)
        const date = new Date(event); // today's date
        const formattedDate = date.toISOString().split('T')[0]; // format to YYYY-MM-DD
        fetchBookings(formattedDate).then(bookings => {
            console.log(bookings)
            const bookedCells = bookings.flatMap(booking => booking.Booking.map(b => ({...b, date: booking.tanggal})));
            setBooked(bookedCells);
          });
      }

      let locationSubHeadingIndex = -1; // This is for tracking when to insert the location subheading

      const moveToNewBooking =()=>{
        navigate("/NewBooking")
      }
      const [openCancellation, setOpenCancellation] = useState(false)
      const [toCancel,setToCancel]=useState();
      const cancelInitiation= (bookingData) => {
        setToCancel(bookingData)
        setOpenCancellation(true)
      }

      const cancelConfirmation = async () => {
        try {
          const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/cancelBookingItem`, { id: toCancel.id });
      
          // Refresh the page or update state as needed here...
          window.location.reload();
        } catch (error) {
          console.error('An error occurred while canceling the booking item.', error);
        }
      }
    return <Grid container style={styles.root}>
    <Dialog open={openCancellation} onClose={(event)=>setOpenCancellation(false)}>
    <Grid sx={{p:3}}>
      <Grid xs={12}>
        <p>Yakin mau cancel?</p>
      </Grid>
      <Grid xs={12} container alignItems={"center"} justifyContent="center">
              <Button color="error" variant="contained" onClick={(event)=>setOpenCancellation(false)}>Jangan</Button>
      </Grid>
      <Grid xs={12} container alignItems={"center"} justifyContent="center">
        <Button variant="contained" sx={{mt:2}} onClick={(event)=>cancelConfirmation(toCancel)}>Yakin</Button>
      </Grid>
    </Grid>
    </Dialog>
    
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                
                    <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                        <Header judul="Kalender" isi="Untuk mengecek booking ruang meeting sesuai tanggal yang dipilih"></Header>
                    </Grid>
                    <Grid sx={{pt:15, ml:7}} >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                    <MobileDatePicker 
                                        views={['year', 'month', 'day']}
                                        inputFormat="dd/MM/yyyy"
                                        value={tanggalBooking}
                                        onChange={(event)=>changeTanggalBooking(event)}
                                        renderInput={(params) => 
                                            <TextField 
                                                {...params} 
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment >
                                                            <CalendarMonthIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        }
                                    />

                        </LocalizationProvider>
                        
                        <Button variant="contained" style={{height: '55px'}} onClick={moveToNewBooking} sx={{ml:2}}>
                            <Typography>Booking Baru +</Typography>
                        </Button>
                    </Grid>
                    
                    <div style={{ transform: 'scale(0.9)'}}>
    <div style={styles.tableWrapper}>
      <TableContainer component={Paper} style={{maxHeight: '65vh', overflow: 'auto', border: '0.3px solid black',   // Thick Border
      boxShadow: '5px 5px 7px grey',}}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={styles.stickyCell}>Nama Ruangan</TableCell>
              {times.map((time, index) => (
                <TableCell key={index} style={styles.cell}>{time}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
    {rooms.flatMap((room, roomIndex) => {
        const elements = []; // This will contain the room row and possibly the location subheading

        // If it's a new location, insert a location subheading
        if (room.location !== rooms[locationSubHeadingIndex]?.location) {
            elements.push(
                <TableRow key={'loc_' + room.location}>
    <TableCell style={{...styles.locationSubheading,...styles.subheadingCell, position: 'sticky', left: 0}}>
        {room.location}
    </TableCell>
    <TableCell colSpan={times.length} style={{...styles.emptyCell ,...styles.subheadingCell,}}>
        {/* Empty Cell */}
    </TableCell>
</TableRow>

            );
            locationSubHeadingIndex = roomIndex;
        }

        // Add the room row
        elements.push(
            <TableRow key={roomIndex}>
                <TableCell style={styles.stickyCell}>{room.name}</TableCell>
                {times.map((time, timeIndex) => {
    const bookingData = booked?.find(
        booking => booking.code === room.code && booking.timeIndex === timeIndex + 1
    );
    
  
    const isBooked = !!bookingData;


    return (
        <Tooltip
            title={
                isBooked 
                ? (
                    <React.Fragment>
                        <div>
                            Nama Klien: {bookingData?.useData?.klien?.Nama || 'no data'}
                        </div>
                        <div>
                            Nama Perusahaan: {bookingData?.useData?.company?.namaPerusahaan || 'no data'}
                        </div>
                        <Button variant="contained" color="primary" onClick={(event)=>cancelInitiation(bookingData)}>
                            Cancel
                        </Button>
                    </React.Fragment>
                )
                : ''
            }
            key={timeIndex}
        >
        <StyledTableCell
                                                                style={{
                                                                  ...styles.cell,
                                                                  backgroundColor: isBooked ? 'red' : 'white',
                                                                  border: '1px solid black',
                    ...styles.cell
                                                                }}
                                                              />
        </Tooltip>
    );
})}
            </TableRow>
        );
        return elements;
    })}
</TableBody>

        </Table>
      </TableContainer>
    </div>
  </div>
                        </Grid>
                    
                </Grid>    
    };